<template lang="pug">
.columns.solutions-columns(v-editable="blok")
	.column.is-half.text-center(v-if="!blok.position_image_right || $viewport.isLessThan('tablet')")
		StoryblokComponent.whitepaper-graph.guide(v-for="blokChild in blok.image_or_video" :key="blokChild._uid" :blok="blokChild")
	.column.is-half.text-section
		h2.text-section-title(v-if="blok.title") {{ blok.title }}
		.body
			component(v-if="richText" :is="{ template: richText, functional: true }")
	.column.is-half.text-center(v-if="blok.position_image_right && $viewport.isGreaterThan('mobile')")
		StoryblokComponent.whitepaper-graph.guide(v-for="blokChild in blok.image_or_video" :key="blokChild._uid" :blok="blokChild")
</template>

<script setup lang="ts">
import { renderRichText } from '@storyblok/vue'

const props = defineProps({
	blok: {
		required: true,
		type: Object
	}
})

const { $viewport } = useNuxtApp()

const escapeHtml = (html: string) => {
	const map = {
		'&': '&amp;',
		'<': '&lt;',
		'>': '&gt;',
		'"': '&quot;',
		'\'': '&#039;'
	}

	return html.replace(/[&<>"']/g, function (m: string) { return map[m as keyof object] })
}
const richText = computed(() => renderRichText(props.blok.text, {
	resolver: (component: any, blok: any) => {
		return `<component :blok="${escapeHtml(JSON.stringify(blok))}" is="${component}" />`
	}
}))
</script>

<style lang="sass" scoped>
:deep(a)
	color: $color-green-60
	&:hover
		color: $color-green-40
.whitepaper-graph
	width: 100%
	:deep(img), :deep(div)
		max-width: 100%
		@media (min-width: $desktop)
			max-width: 550px
	@media (max-width: 768px)
		margin-top: $spacing-32
.solutions-columns
	@media (min-width: $desktop)
		align-items: center
.text-and-image-columns
	align-items: center
	margin-top: $spacing-64
h2
	@include font(basier, bold)
	@include fontSize(xxl)
	@media (min-width: $tablet)
		@include fontSize(3xl)
.body
	color: #fff
	@include fontSize(m)
	line-height: 30px
	margin-top: $spacing-32
	padding-bottom: $spacing-32
	max-width: 600px
	&:deep(ul)
		list-style: disc!important
		margin-left: 24px
		margin-bottom: 32px
		li
			color: #848484!important
			font-size: 21px
			line-height: 30px
</style>
